import { Box, Container, Icon, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import React from 'react';
import { NavLink, Redirect, Route, Switch } from 'react-router-dom';

import { RequireRole } from 'app/components/require-role';

import { Role } from 'app/constants/role';

import { MLSamples } from './ml-samples';
import { PatternExplorer } from './pattern-explorer';
import { Search } from './search';
import { TupleExplorer } from './tuple-explorer';
import { NotFound } from '../../app/components/not-found';

export class Explore extends React.Component {
    public render(): React.ReactNode {
        return (
            <Box display='flex'>
                <Box className='p-2'>
                    <List>
                        <ListItem button activeClassName='Mui-selected' component={NavLink} to='/explore/search'>
                            <ListItemIcon>
                                <Icon>search</Icon>
                            </ListItemIcon>
                            <ListItemText primary='Search' />
                        </ListItem>
                        <ListItem button activeClassName='Mui-selected' component={NavLink} to='/explore/tuples'>
                            <ListItemIcon>
                                <Icon>fact_check</Icon>
                            </ListItemIcon>
                            <ListItemText primary='Tuples' />
                        </ListItem>
                        <ListItem button activeClassName='Mui-selected' component={NavLink} to='/explore/patterns'>
                            <ListItemIcon>
                                <Icon>grain</Icon>
                            </ListItemIcon>
                            <ListItemText primary='Patterns' />
                        </ListItem>
                        <RequireRole roles={Role.TUNER}>
                            <ListItem
                                button
                                activeClassName='Mui-selected'
                                component={NavLink}
                                to='/explore/ml-samples'
                            >
                                <ListItemIcon>
                                    <Icon>science</Icon>
                                </ListItemIcon>
                                <ListItemText primary='ML Samples' style={{ whiteSpace: 'nowrap' }} />
                            </ListItem>
                        </RequireRole>
                    </List>
                </Box>
                <Box flexGrow={1} className='p-2'>
                    <Container maxWidth={false}>
                        <Switch>
                            <Route exact path='/explore'>
                                <Redirect to='/explore/search' />
                            </Route>
                            <Route path='/explore/tuples'>
                                <TupleExplorer />
                            </Route>
                            <Route path='/explore/patterns'>
                                <PatternExplorer />
                            </Route>
                            <Route path='/explore/search'>
                                <Search />
                            </Route>
                            <Route path='/explore/ml-samples'>
                                <MLSamples />
                            </Route>
                            <Route path='*'>
                                <NotFound />
                            </Route>
                        </Switch>
                    </Container>
                </Box>
            </Box>
        );
    }
}
